import type { IChevronDown } from './helpers';

export const ChevronDown = ({ mobileMenu = false, ...rest }: IChevronDown) => {
	if (!mobileMenu) {
		return (
			<svg
				width='12'
				height='6'
				viewBox='0 0 12 6'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				data-testid='chevron-icon'
				{...rest}
			>
				<path
					d='M11.687 0.854028L6.68704 5.85403C6.6406 5.90052 6.58545 5.9374 6.52476 5.96256C6.46406 5.98772 6.39899 6.00067 6.33329 6.00067C6.26758 6.00067 6.20251 5.98772 6.14182 5.96256C6.08112 5.9374 6.02597 5.90052 5.97954 5.85403L0.979536 0.854028C0.885715 0.760208 0.833008 0.63296 0.833008 0.500278C0.833008 0.367596 0.885715 0.240348 0.979536 0.146528C1.07336 0.0527074 1.2006 0 1.33329 0C1.46597 0 1.59322 0.0527074 1.68704 0.146528L6.33329 4.7934L10.9795 0.146528C11.026 0.100073 11.0811 0.0632225 11.1418 0.0380812C11.2025 0.0129398 11.2676 0 11.3333 0C11.399 0 11.464 0.0129398 11.5247 0.0380812C11.5854 0.0632225 11.6406 0.100073 11.687 0.146528C11.7335 0.192983 11.7703 0.248133 11.7955 0.30883C11.8206 0.369526 11.8336 0.434581 11.8336 0.500278C11.8336 0.565975 11.8206 0.63103 11.7955 0.691726C11.7703 0.752423 11.7335 0.807573 11.687 0.854028Z'
					fill='#131515'
				/>
			</svg>
		);
	}

	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			data-testid='chevron-icon'
			{...rest}
		>
			<path
				d='M5 7.5L10 12.5L15 7.5'
				stroke='#667085'
				strokeWidth='1.67'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};
